module.exports = __webpack_public_path__ + "img/ring_r_e_0_null.21a1af7e.png";